import axiosInstance from "../axios";
import {
    AuthUserRequest,
    AuthUserResponse, ChangePasswordRequest, ChangePasswordResponse,
    ForgotPasswordRequest, ForgotPasswordResponse,
    RegisterUserRequest,
    RegisterUserResponse
} from "../../types";

/**
 * API авторизации\аутентификации пользователей
 */
export default class UserAuthApi
{
    /**
     * Регистрация пользователя
     * @param request
     */
    public registerUserRequest(request: RegisterUserRequest): Promise<RegisterUserResponse>
    {
        return new Promise((resolve, reject) => {
            const params = new URLSearchParams();
            params.append('email', request.email);
            params.append('nickname', request.nickname);
            params.append('is_adult', request.is_adult ? '1' : '0');
            params.append('first_name', request.first_name);
            params.append('last_name', request.last_name);
            params.append('password', request.password);
            params.append('password_confirmation', request.password_confirmation);

            axiosInstance.post('/profile/auth/register', params).then(response => {
                if (typeof response.data.error === 'undefined') {
                    resolve(response.data.response);
                } else {
                    reject(response.data.error);
                }
            }).catch(error => {
                reject(error);
            });
        });
    }

    /**
     * Получение токена авторизации пользователя
     * @param request
     */
    public authUserRequest(request: AuthUserRequest): Promise<AuthUserResponse>
    {
        return new Promise((resolve, reject) => {
            const params = new URLSearchParams();
            params.append('email', request.email);
            params.append('password', request.password);

            axiosInstance.post('/profile/auth/get-token', params).then(response => {
                if (typeof response.data.error === 'undefined') {
                    resolve(response.data.response);
                } else {
                    reject(response.data.error);
                }
            }).catch(error => {
                reject(error);
            });
        });
    }

    /**
     * Отправка запроса на изменение пароля
     * @param request
     */
    public forgotPasswordRequest(request: ForgotPasswordRequest): Promise<ForgotPasswordResponse>
    {
        return new Promise((resolve, reject) => {
            const params = new URLSearchParams();
            params.append('email', request.email);

            axiosInstance.post('/profile/auth/forgot-password', params).then(response => {
                if (typeof response.data.error === 'undefined') {
                    resolve(response.data.response);
                } else {
                    reject(response.data.error);
                }
            }).catch(error => {
                reject(error);
            });
        });
    }

    /**
     * Отправка запроса на изменение пароля
     * @param request
     */
    public changePasswordRequest(request: ChangePasswordRequest): Promise<ChangePasswordResponse>
    {
        return new Promise((resolve, reject) => {
            const params = new URLSearchParams();
            params.append('id', request.id.toString());
            params.append('password', request.password);
            params.append('password_confirmation', request.password_confirmation);
            params.append('hash', request.hash);

            axiosInstance.post('/profile/auth/change-password', params).then(response => {
                if (typeof response.data.error === 'undefined') {
                    resolve(response.data.response);
                } else {
                    reject(response.data.error);
                }
            }).catch(error => {
                reject(error);
            });
        });
    }
}
